<template>
  <div>
    <DashShellComponent :has-data="!!selectedCase" :tabs="invoiceTabs">
      <!-- Slot for Selection Pane -->
      <template #selection-pane>
        <SelectionPane :fileFormatter="formatCases" @selected="handleSelection" @add-to-ledger="handleNewEntry" @context-changed="getSelectedContext"></SelectionPane>
        <!-- <v-card class="mb-4 mt-3" color="blue-grey lighten-5" outlined>
          <div class="mx-4 mt-3">
            <h3 class="mb-2">1. Select What You Want To Work On</h3>

            <v-select
              :items="[`${matterLabel}s`, `Clients Accounts`, `Quotations`]"
              label="Select What You Want To Work On"
              v-model="selectedContext"
              @change="getSelectedContext"
              outlined
            >
              <template v-slot:item="{ item, on, attrs }">
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">
                    {{ item }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-select>
          </div>

          <div v-if="selectedContext">
            <div v-if="selectedContext === `${matterLabel}s`">
              <h3 class="mx-4">2. Add or Manage {{ matterLabel }}s</h3>
              <v-card-text>
                <v-autocomplete
                  v-model="selectedCase"
                  @change="getSelectedCase"
                  :items="formattedCases"
                  :label="`Add or Search ${matterLabel} (Ref / Court No / SAPS No)`"
                  prepend-inner-icon="mdi-magnify"
                  outlined
                  hide-details
                  placeholder="Type to search..."
                >
                  <template v-slot:prepend-item>
                    <v-list-item
                      ripple
                      @click.prevent="showAddCasesDialog = true"
                    >
                       <v-list-item-icon><v-icon color="success">mdi-plus-circle</v-icon></v-list-item-icon> 
                      <v-list-item-content>
                        <v-list-item-title
                          class="success--text font-weight-bold"
                          ><v-btn color="primary" block
                            ><v-icon dark left>mdi-plus-circle</v-icon>Add New
                            Case</v-btn
                          ></v-list-item-title
                        >
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mb-2"></v-divider>
                  </template>

                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item-content>
                      <v-list-item-title class="text-wrap">
                        {{ item.clientName }}
                        <small class="grey--text d-block">
                          {{ item.internalRef + " | " + item.courtCaseNo }}
                        </small>
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action class="flex-row">
                      <v-btn
                        icon
                        small
                        color="primary"
                        @click.stop="openDialog('edit', item)"
                      >
                        <v-icon small>mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        small
                        color="error"
                        @click.stop="openDialog('delete', item)"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </template>
                </v-autocomplete>

                <div v-if="selectedCase">
                  <billing-timer @add-to-ledger="handleNewEntry" />
                </div>
              </v-card-text>
            </div>
            <div v-else-if="selectedContext === `Clients Accounts`">
              <div
                class="mt-3"
                color="blue-grey lighten-5"
                outlined
                v-if="!selectedCase"
              >
                <h3 class="mx-4 mb-4">2. Clients Accounts & Invoices</h3>
                <AutoCompleteCrudAdvanced
                  class="mx-4"
                  table="clients"
                  label="Clients Accounts & Invoices"
                  @input="getSelectedClient"
                ></AutoCompleteCrudAdvanced>
              </div>
            </div>
            <div v-else-if="selectedContext === `Quotations`">
              <h3 class="mx-4 mb-4">2. Create or Manage Quotes</h3>
              <AutoCompleteCrudAdvanced
                class="mx-4"
                table="quotations"
                label="Create or Manage Quotes"
                :formatter="formatQuotes"
                @input="getSelectedQuote"
              ></AutoCompleteCrudAdvanced>
            </div>
          </div>
        </v-card> -->
      </template>

      <!-- Slot for Header -->
      <template #header-content>
        <HeaderAndContent
          :selectedInvoice="selectedCase"
          :selectedClient="selectedClient"
          :selectedQuote="selectedQuote"
        />
      </template>
    </DashShellComponent>

    <add-cases-dialog
      v-model="showAddCasesDialog"
      @case-added="handleAddCases"
    />

    <v-dialog persistent max-width="600px" v-model="deleteCaseDialog">
      <v-card v-if="caseToBeDeleted">
        <v-card-title style="background-color: red; color: white">
          Confirm Delete
        </v-card-title>
        <v-card-text>
          You are about to
          <strong>Delete Case {{ caseToBeDeleted.text }}</strong
          >. this action cannot be reversed. <br />
          All data related to this case will also be deleted. click confirm to
          delete.
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="closeDeleteCaseDialog()">Cancel</v-btn>
          <v-btn color="red" dark @click="deleteCaseNow(caseToBeDeleted.value)"
            >Confirm Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import helpersJs from "@/plugins/helpers";
import companiesJs from "@/plugins/companies";
import AutoCompleteCrudAdvanced from "@/modules/CrudDatabases/AutoCompleteCrudAdvanced.vue";
import Quotations from "@/modules/InvoicesAndQuotes/Quotations.vue";
import AddCasesDialog from "./AddCasesDialog.vue";

import BillingTimer from "./BillingTimer.vue";
// import ProFormaGenerator from './ProFormaGenerator.vue';
import CaseChronology from "./CaseChronology.vue";
import CaseDocumentsManager from "./CaseDocumentsManager.vue";
import CaseDetailCard from "./CaseDetailCard.vue";
import CaseDetailHeader from "./CaseDetailHeader.vue";

import SelectionPane from "@/components/General/SelectionPane.vue";
import ClientManager from "@/modules/Clients/ClientManager.vue";
import TrustAccountLedger from "@/modules/TrustAccount/TrustAccountLedger.vue";
import BillingItemsTable from "./BillingItemsTable.vue";
import WelcomeNotice from "@/components/General/WelcomeNotice.vue";
import InvoicePageHeader from "@/modules/InvoicesAndQuotes/InvoicePageHeader.vue";
import HeaderAndContent from "@/components/General/HeaderAndContent.vue";
import DashShellComponent from "@/components/General/DashShellComponent.vue";

export default {
  name: "CaseFile",
  components: {
    AddCasesDialog,
    AutoCompleteCrudAdvanced,
    BillingTimer,
    CaseChronology,
    Quotations,
    CaseDocumentsManager,
    CaseDetailCard,
    ClientManager,
    TrustAccountLedger,
    BillingItemsTable,
    WelcomeNotice,
    CaseDetailHeader,
    InvoicePageHeader,
    HeaderAndContent,
    DashShellComponent,
    SelectionPane
  },
  computed: {
    matterLabel() {
      return "Case";
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getAuthenticated() {
      return this.$store.getters.getAuthenticated;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getTrustAccLabel() {
      return this.$store.getters.getTrustAccLabel;
    },
    getTertiaryColor() {
      return "#000";
    },
    totalBillable() {
      var total = 0;
      if (
        !this.selectedCase ||
        !this.selectedCase.billingEntries ||
        this.selectedCase.billingEntries.length < 1
      ) {
        return total;
      }

      for (var i = 0; i < this.selectedCase.billingEntries.length; i++) {
        var entry = this.selectedCase.billingEntries[i];
        total += Number(entry.price) + this.calculateVAT(entry);
      }

      return total;
    },
    // formattedCases() {
    //   if (!this.allCases || this.allCases.length < 1) {
    //     return [];
    //   }

    //   const cases = this.allCases.map(item => {
    //     return {
    //       text: item.internalRef,
    //       value: item,
    //       internalRef: item.internalRef,
    //       courtCaseNo: item.courtCaseNo,
    //       clientName: item.clientName,
    //       sapsCaseNo: item.sapsCaseNo
    //     };
    //   });

    //   return cases;
    // },
    invoiceTabs() {
      if (!this.selectedCase) return [];

      return [
        {
          label: "3. Billing & Expenses",
          mobileLabel: "3. Billing",
          icon: "mdi-cash-register",
          component: BillingItemsTable,
          props: {
            selectedInvoice: this.selectedCase,
            itemLabel: "Invoice",
            referenceNumber: "invoice_no",
          },
          on: {
            "billing-added": this.refreshBillingEntries,
          },
        },
        {
          label: `4. ${this.getTrustAccLabel} Account`,
          mobileLabel: "4. Account",
          icon: "mdi-bank-outline",
          component: TrustAccountLedger,
          props: {
            scope: "case",
            reference: this.selectedCase.invoice_number,
          },
        },
        {
          label: `5. Case Details`,
          mobileLabel: "5. Case ",
          icon: "mdi-folder-account",
          component: CaseDetailCard,
          props: {
            selectedCase: this.selectedCase,
          },
          on: {
            save: this.refreshSelectedCase,
          },
        },
        {
          label: "6. Activities & Tasks",
          mobileLabel: "6. Tasks",
          icon: "mdi-format-list-checks",
          component: CaseChronology,
          props: {
            caseData: this.selectedCase,
          },
        },
        {
          label: "7. Documents",
          mobileLabel: "7. Docs",
          icon: "mdi-file-document-multiple",
          component: CaseDocumentsManager,
          props: {
            selectedCase: this.selectedCase,
            emis: this.selectedCase.emis,
          },
          on: {
            "refresh-documents": this.refreshDocs,
          },
        },
      ];
    },
  },
  data() {
    return {
      selectedContext: null,
      absolute: true,
      overlay: false,

      quotations: [],

      activeTab: null,
      caseTypes: [
        "RAF - Identified",
        "RAF - Hit & Run",
        "Medical Malpractice",
        "General Litigation",
      ],

      caseToBeDeleted: null,
      deleteCaseDialog: false,

      //add cases dialog
      showAddCasesDialog: false,

      //billing entry dialog
      showBillingDialog: false,
      billingSearch: "",
      ledgerFilter: "All",
      deleteBillingEntryDialog: false,
      deleteBillingEntryItem: null,
      allCases: [],
      // allCases:[
      // {
      //   emis:"1234567890",
      //   internalRef: 'LAW-2023-0045',
      //   courtCaseNo: '12345/2023',
      //   sapsCaseNo: 'CAS 44/05/2023',
      //   clientRef: 12321,
      //   clientName: 'J. Doe',
      //   status: 'Summons Issued',
      //   prescriptionDate: '2026-05-20',
      //   accidentDate: '2023-05-20',
      //   accidentLocation: 'N1 North, Johannesburg',
      //   meritsSummary: 'Client rear-ended by a heavy motor vehicle...',
      //   trustBalance: 50000.00,
      //   documents: [
      //     { name: 'SAPS_Statement.pdf', date: '2023-06-01' },
      //     { name: 'Medical_Report_Dr_Smith.pdf', date: '2023-08-15' }
      //   ],
      //   billingEntries: [
      //     { id:1, type: 'Fee', description: 'Consultation with Client', amount: 1500.00, isVatable: true },
      //     { id:2, type: 'Disbursement', description: 'Sheriff Fees', amount: 450.00, isVatable: false }
      //   ],
      //   chronology: [
      //         { date: '2026-01-10', description: 'Summons served via Sheriff', author: 'Adv. Mthuli', type: 'milestone' }
      //     ],
      //     tasks: [
      //         { id: 101, title: 'Obtain Clinical Records from Baragwanath', status: 'todo', assignedTo: 'Clerk A', start:'2026-02-25', end: '2026-02-25' }
      //     ]
      // },
      // {
      //   emis:"1234567890",
      //   internalRef: 'LAW-2025-1025',
      //   courtCaseNo: '12349/2025',
      //   sapsCaseNo: 'CAS 44/05/2023',
      //   clientRef: 12321,
      //   clientName: 'Kenneth Franklin',
      //   status: 'Initial Enquiry',
      //   prescriptionDate: '2026-01-12',
      //   accidentDate: '2025-01-12',
      //   accidentLocation: '123 Street, Polokwane',
      //   meritsSummary: 'Client rear-ended by a heavy a bicycle ...',
      //   trustBalance: 10000.00,
      //   documents: [
      //   { name: 'Traffic_Department_Statement.pdf', date: '2025-06-01' },
      //     { name: 'SAPS_Statement.pdf', date: '2025-06-01' },
      //     { name: 'Medical_Report_Dr_Smith.pdf', date: '2025-08-15' }
      //   ],
      //   billingEntries: [
      //     { id:1, type: 'Fee', description: 'Consultation with Client', amount: 1200.00, isVatable: true },
      //     { id:1, type: 'Fee', description: 'Drafting Affidavit', amount: 900.00, isVatable: true },
      //     { id:2, type: 'Disbursement', description: 'Sheriff Fees', amount: 1450.00, isVatable: false }
      //   ],
      //   chronology: [
      //         { date: '2026-01-10', description: 'Summons served via Sheriff', author: 'Adv. Mthuli', type: 'milestone' }
      //     ],
      //     tasks: [
      //         { id: 101, title: 'Obtain Clinical Records from Baragwanath', status: 'todo', assignedTo: 'Clerk A', start:'2026-02-25', end: '2026-02-25' }
      //     ]
      // },
      // ],
      selectedCase: null,
      selectedClient: null,
      selectedQuote: null,
      docHeaders: [
        { text: "File Name", value: "name" },
        { text: "Upload Date", value: "date" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      billingHeaders: [
        { text: "Del", value: "id" },

        { text: "Description", value: "name" },
        { text: "Amount (Excl)", value: "price" },
        { text: "VAT (15%)", value: "tax_amount", sortable: false },
        { text: "Total", value: "lineTotal", sortable: false },
      ],
    };
  },
  // async mounted() {
  //   await this.initialiseComponent();
  // },
  methods: {
    formatCases({ cases }) {
      if (!cases || !cases.length) return [];
      const formattedCases = [];

      cases.forEach((casse) => {
        formattedCases.push({
          ...casse,
          name: `${casse.clientName} | ${casse.internalRef}`,
        });
      });
      
      return formattedCases;
    },
    getSelectedContext() {
      this.selectedCase = null;
      this.selectedClient = null;
      this.selectedQuote = null;
    },
    // formatQuotes({ quotes }) {
    //   if (!quotes || !quotes.length) return [];
    //   const quotations = [];

    //   quotes.forEach((quote) => {
    //     quotations.push({
    //       ...quote,
    //       name: `${quote.client?.name} | ${quote.quote_number}`,
    //     });
    //   });
    //   this.quotations = quotations;
    //   return quotations;
    // },
    //done
    getSelectedQuote(quote) {
      this.selectedClient = null;
      this.selectedCase = null;
      this.selectedQuote = quote;
    },
    //done
    refreshSelectedCase(selectedCase) {
      this.selectedCase = selectedCase;
    },
    //done
    getSelectedClient(selectedClient) {
      this.selectedCase = null;
      this.selectedQuote = null;
      this.selectedClient = selectedClient;
    },
    handleSelection(selection){
          if(!selection) return;
          const category = selection.category
          const selectedItem = selection.data
          this.selectedContext = true;

            if(category === 'primary'){
              this.getSelectedCase(selectedItem)
            }else if(category === 'client'){
              this.getSelectedClient(selectedItem)
            }else{ //its a quote
              this.getSelectedQuote(selectedItem)
            }
        },
    //done
    getSelectedCase(selectedCase) {
      this.selectedClient = null;
      this.selectedQuote = null;
      this.selectedCase = selectedCase
    },
    //done (postponed, selectedinvoice must be turned into selectedCase if legal)
    getAndSetConvertedInvoice(convertedInvoice) {
      this.selectedClient = null;
      this.selectedQuote = null;
      this.selectedInvoice = convertedInvoice;
    },
    //done
    // async getSelectedPhase(matterPhase) {
    //   if (!this.selectedCase || !matterPhase) return;
    //   await this.updateModelSingleRow(
    //     "legal_cases",
    //     "matter_phase",
    //     this.selectedCase.id,
    //     matterPhase.name
    //   );
    // },
    //done
    async initialiseComponent() {
      if (!this.getAuthenticated) {
        return;
      }
      const userCompany = await companiesJs.getUserCompany();
      helpersJs.initialiseOrUpdateCompanyDataInStorage(null, userCompany);

      await this.getAllLegalCases();
    },
    //done
    refreshDocs(docs) {
      this.selectedCase.documents = docs;
    },
    //done
    async getAllLegalCases() {
      this.$store.commit("setLoader", true);
      axios
        .getData("/auth/get-all-legal-cases", this.getAccessToken)
        .then((res) => {
          this.$store.commit("setLoader", false);
          if (res && res.status === "success") {
            this.allCases = res.cases;
            this.$store.commit("setAllCases", res.cases);
          } else {
            this.$toast.error(res.message, { duration: 5000 });
          }
        });
    },
    //done
    // openDeleteCase(item) {
    //   this.caseToBeDeleted = item;
    //   this.deleteCaseDialog = true;
    // },
    //done
    closeDeleteCaseDialog() {
      this.deleteCaseDialog = false;
      this.caseToBeDeleted = null;
    },
    //done
    deleteCaseNow(caseObj) {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/delete-case-by-id",
          { caseID: caseObj.id },
          this.getAccessToken
        )
        .then((res) => {
          this.$store.commit("setLoader", false);
          this.closeDeleteCaseDialog();
          if (res && res.status === "success") {
            this.$toast.success(res.message, { duration: 10000 });
            this.caseToBeDeleted = null;
            this.allCases = [];
            this.getAllLegalCases();
          } else {
            this.$toast.error(res.message, { duration: 10000 });
          }
        });
    },
    //done
    async updateModelSingleRow(table, column, id, value) {
      this.$store.commit("setLoader", true);
      await helpersJs.updateModelSingleRow(table, column, id, value);
      this.$store.commit("setLoader", false);
      this.$toast.success("Data updated successfully!", { duration: 5000 });
    },
    //done
    async updateSelectedCaseFields(columnName) {
      this.updateModelSingleRow(
        "legal_cases",
        columnName,
        this.selectedCase.id,
        this.selectedCase[columnName]
      );
    },
    //done
    async updateClaimType(claimObj) {
      this.selectedCase.claimType = claimObj.name;
      this.updateModelSingleRow(
        "legal_cases",
        "claimType",
        this.selectedCase.id,
        claimObj.name
      );
    },
    //done
    calculateVAT(item) {
      if (item.isVatable) {
        return Number(item.price) * 0.15;
      }
      return 0;
    },
    //done
    formatCurrency(value) {
      if (!value || value === 0) {
        return this.getCurrency + "0";
      }
      return this.getCurrency + helpersJs.formatMoney(value);
    },
    //done
    getSelectedStatus(statusObj) {
      this.selectedCase.status = statusObj.name;
      this.updateCaseStatus();
    },
    //done
    // updateCaseStatus() {
    //   if (
    //     !this.selectedCase ||
    //     !this.selectedCase.internalRef ||
    //     !this.selectedCase.status
    //   ) {
    //     this.$toast.error("Select a case before updating its status", {
    //       duration: 10000,
    //     });
    //     return false;
    //   }

    //   this.$store.commit("setLoader", true);
    //   axios
    //     .postDataWithToken(
    //       "/auth/update-case-status",
    //       {
    //         internalRef: this.selectedCase.internalRef,
    //         status: this.selectedCase.status,
    //       },
    //       this.getAccessToken
    //     )
    //     .then((res) => {
    //       this.$store.commit("setLoader", false);
    //       if (res && res.status == "success") {
    //         this.$toast.success(
    //           "status for case with reference " +
    //             this.selectedCase.internalRef +
    //             " has been updated to " +
    //             this.selectedCase.status,
    //           { duration: 10000 }
    //         );
    //         this.selectedCase.statusColor = res.statusColor;
    //       } else {
    //         this.$toast.error(res.message, { duration: 10000 });
    //       }
    //     });
    // },
    //done
    addBillingEntry() {
      this.showBillingDialog = true;
    },
    refreshBillingEntries(billingEntries) {
      this.selectedCase.billingEntries = billingEntries;
    },
    //done
    handleNewEntry(newEntry) {
      this.selectedCase.billingEntries.push(newEntry);

      this.$store.commit("setLoader", true);

      axios
        .postDataWithToken(
          "/auth/save-or-update-case-billings",
          {
            internalRef: this.selectedCase.internalRef,
            invoiceNo: this.selectedCase.invoice_no,
            billingEntries: this.selectedCase.billingEntries,
          },
          this.getAccessToken
        )
        .then((res) => {
          this.$store.commit("setLoader", false);
          if (res && res.status == "success") {
            this.$toast.success(
              "Billing entry added!, see it under Billing & Ledger",
              { duration: 10000 }
            );
            this.selectedCase.billingEntries = res.billingEntries;
          } else {
            this.$toast.error("Oops, something went wrong!", {
              duration: 10000,
            });
          }
        });
    },
    //done
    handleAddCases(newCase) {
      this.allCases.push(newCase);
      this.$toast.success(
        "New case captured!, select it from the select cases drop down",
        { duration: 10000 }
      );
    },

    //done utility mfunctions
    // filterByType: function (value, search, item) {
    //   // 1. Handle Type Filter
    //   if (this.ledgerFilter !== "All" && item.type !== this.ledgerFilter) {
    //     return false;
    //   }

    //   // 2. Handle Text Search (Case Insensitive)
    //   if (search) {
    //     var description = item.description.toLowerCase();
    //     var amount = item.amount.toString();
    //     return (
    //       description.indexOf(search.toLowerCase()) !== -1 ||
    //       amount.indexOf(search) !== -1
    //     );
    //   }

    //   return true;
    // },
  },
};
</script>

<style scoped>
.v-tab {
  text-transform: none !important;
  font-weight: 600;
}

/* v-tabs styling */
/* Glassmorphic layout wrapper for the tab tray */
.modern-tabs-container {
  background: rgba(245, 247, 250, 0.85) !important;
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px 12px 0 0;
}

/* Inactive base tab styling */
.modern-tab-item {
  letter-spacing: 0.3px !important;
  font-weight: 600 !important;
  font-size: 0.875rem !important;
  text-transform: none !important;
  border-radius: 8px !important;
  min-height: 44px !important;
  color: #546e7a !important;
  background-color: transparent !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* Affordance Feedback: Dynamic lift and color swap on hover tells user it is clickable */
.modern-tab-item:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
  color: #263238 !important;
  transform: translateY(-1px);
}

/* Active State: Rich theme color gradient styling */
.active-gradient-tab {
  /* Automatically inherits your dynamic theme color property values */
  background: linear-gradient(
    135deg,
    var(--v-primary-base, #1976d2) 0%,
    #1565c0 100%
  ) !important;
  color: white !important;
  transform: translateY(0) scale(1.02);
}

/* Alternating subtle accent fallback specifically for the secondary elements if preferred */
.modern-tab-item:nth-child(even).active-gradient-tab {
  background: linear-gradient(135deg, #607d8b 0%, #455a64 100%) !important;
}

.active-gradient-tab .tab-icon {
  color: white !important;
}

/* Mobile responsive constraints */
@media (max-width: 600px) {
  .tab-text {
    font-size: 0.8rem !important;
  }
  .modern-tab-item {
    padding: 0 12px !important;
    min-width: auto !important;
  }
}

/* billings and expenses header */

.border-green {
  border-color: #c8e6c9 !important; /* Soft green boundary instead of a heavy card shadow */
}
.lh-tight {
  line-height: 1.2;
}
.tracking-wide {
  letter-spacing: 0.05em;
}
</style>
